// Event countdown chip config — persistent header pill (Command Center) +
// public-landing scarcity pill. Central config so the date only has to
// change in one place.
//
// STATUS 2026-08-14: Middleton Seminar CANCELLED (schedule conflict).
// The chip auto-hides when `SEMINAR_ENABLED === false` OR when the target
// date is in the past. To re-enable for a new event (workshop, launch,
// Facebook Live, etc.), flip `SEMINAR_ENABLED` back to true and update
// the label + date below.

export const SEMINAR_ENABLED  = false;                       // ← flip to true to reactivate
export const SEMINAR_DATE_ISO = "2026-08-29T09:00:00-04:00"; // legacy target
export const SEMINAR_LABEL    = "Middleton Seminar";
export const SEMINAR_HREF     = "/v3/calendar";
export const SEMINAR_PUBLIC_HREF = "/middleton";

/** Returns { days, expired, targetDate } for the current time.
 *  Returns `expired: true` whenever the feature flag is off so every
 *  consumer (SeminarCountdownChip, banners, etc.) hides itself. */
export function seminarCountdown(now = new Date()) {
  const target = new Date(SEMINAR_DATE_ISO);
  const diffMs = target.getTime() - now.getTime();
  const days   = Math.ceil(diffMs / (24 * 60 * 60 * 1000));
  return {
    days,
    expired:    !SEMINAR_ENABLED || diffMs <= 0,
    targetDate: target,
  };
}
